import createIcon from '../../createIcon';

/**
 * @component @name ImageNotSupported
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNjA0NSAyMS4xOTQ1TDIuODA0NTMgMS4zOTQ1M0wxLjM5NDUzIDIuODA0NTNMMy43MDQ1MyA1LjEyNDUzVjE4LjI5NDVDMy43MDQ1MyAxOS4zOTQ1IDQuNjA0NTMgMjAuMjk0NSA1LjcwNDUzIDIwLjI5NDVIMTguODc0NUwyMS4xODQ1IDIyLjYwNDVMMjIuNjA0NSAyMS4xOTQ1Wk01LjcwNDUzIDE3LjI5NDVMOS4yMDQ1MyAxMi43OTQ1TDExLjcwNDUgMTUuODA0NUwxMi44NzQ1IDE0LjI5NDVMMTUuODc0NSAxNy4yOTQ1SDUuNzA0NTNaTTIxLjcwNDUgMTcuNDY0NUw2LjUzNDUzIDIuMjk0NTNIMTkuNzA0NUMyMC44MDQ1IDIuMjk0NTMgMjEuNzA0NSAzLjE5NDUzIDIxLjcwNDUgNC4yOTQ1M1YxNy40NjQ1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ImageNotSupported = createIcon('ImageNotSupported', [
  [
    'path',
    {
      d: 'M22.6045 21.1945L2.80453 1.39453L1.39453 2.80453L3.70453 5.12453V18.2945C3.70453 19.3945 4.60453 20.2945 5.70453 20.2945H18.8745L21.1845 22.6045L22.6045 21.1945ZM5.70453 17.2945L9.20453 12.7945L11.7045 15.8045L12.8745 14.2945L15.8745 17.2945H5.70453ZM21.7045 17.4645L6.53453 2.29453H19.7045C20.8045 2.29453 21.7045 3.19453 21.7045 4.29453V17.4645Z',
      key: '1kanze',
    },
  ],
]);

export default ImageNotSupported;
